import { render, staticRenderFns } from "./NewFolder.vue?vue&type=template&id=0a3b2596"
import script from "./NewFolder.vue?vue&type=script&lang=js"
export * from "./NewFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports